import { EVENT_TYPES_CODES } from 'events/constants/EventsConstants'
import { max, upperFirst } from 'lodash'
import moment from 'moment'
import React from 'react'
import { getDateWithHour } from '../../../utils/DateUtil'
import { getMaterielIconValue } from '../../../utils/MaterielUtils'
import { getLabel } from '../../../utils/StoreUtils'
import { EVENT_ACTION } from '../../constants/PiezometryEventConstants'
import { darkBlue } from 'utils/constants/ColorTheme'
import { CardTitle } from 'components/card/NewCard'

const centralAction = [
    EVENT_ACTION.MESURE_TENSION_CENTRALE,
    EVENT_ACTION.REMPLACEMENT_PILES_CENTRALE,
    EVENT_ACTION.REINITIALISATION_STATION,
    EVENT_ACTION.FIRMWARE_MIS_A_JOUR,
]

const telecomAction = [
    EVENT_ACTION.MESURE_TENSION_TELETRANSMISSION,
    EVENT_ACTION.REMPLACEMENT_PILES_TELETRANSMISSION,
    EVENT_ACTION.TEST_TRANSMISSION,
]

const sensorAction = [
    EVENT_ACTION.RECALIBRATION_CAPTEUR,
    EVENT_ACTION.REMPLACEMENT_PILES_CAPTEUR,
    EVENT_ACTION.TENSION_PILES_CAPTEUR,
    EVENT_ACTION.DESSICANT_REMPLACE,
    EVENT_ACTION.REMPLACEMENT_MESURE_NIVEAU,
]

const getActualMateriel = (stationType, materielCategory, materielList, props) => {
    const previousSituation = props[`${stationType + upperFirst(materielCategory)}Assignment`].filter(s => !s.situationEndDate || s.situationEndDate > moment().valueOf())
    return previousSituation.map(s => materielList.find(m => m.id === s.materielId)).filter(m => !!m)
}

const isLastEvent = (events = [], event = {}) => {
    const eventsDate = events.map(e => getDateWithHour(e.date, e.eventHour).valueOf())
    const lastDate = max(eventsDate)
    const eventDate = getDateWithHour(event.date, event.eventHour)?.valueOf() || 0
    return events.length ? eventDate >= lastDate : true
}

const getYesOrNo = className => (
    <tr className={className}>
        <th className='no-padding' />
        <th className='no-padding'>
            <div className='valign-wrapper chip' style={{ background: 'green' }}>
                <h5 className='center-align no-margin white-text font-size-17' style={{ 'padding-top': '7px' }}>OUI</h5>
            </div>
        </th>
        <th className='no-padding'>
            <div className='valign-wrapper chip' style={{ background: 'red' }}>
                <h5 className='center-align no-margin white-text font-size-17' style={{ 'padding-top': '7px' }}>NON</h5>
            </div>
        </th>
    </tr>
)

const getTitleCard = (title, materielCategory, materiel, materielTypes) => (
    <CardTitle
        title={title}
        subtitleSize={2}
        subTitle={`${getLabel(materielTypes, materiel.materielType)} ${materiel.imei || materiel.serialNumber || ''}`}
        icon={getMaterielIconValue(materielCategory)}
        color={darkBlue}
    />
)

const getActionMaterielType = action => {
    if (centralAction.includes(action)) {
        return 'central'
    }
    if (sensorAction.includes(action)) {
        return 'sensor'
    }
    if (telecomAction.includes(action) || action.includes('TEST_SIGNAL')) {
        return 'telecom'
    }
    return ''
}

const isUpdatableEvent = (event = {}, situations = []) => {
    return !situations.length
        || event.eventType === EVENT_TYPES_CODES.TO_PLAN
        || event.eventType === EVENT_TYPES_CODES.TO_MONITOR
        || event.eventType === EVENT_TYPES_CODES.COMMENT
}

export { getActualMateriel, getYesOrNo, getTitleCard, isLastEvent, getActionMaterielType, isUpdatableEvent }
